"use client";

import Link from "next/link";
import { lazyComponent } from "@/components/ui/lazy-component";
import { getProductTypeBySlug } from "@/lib/generated/product-types";

const GRADED_PALLET = getProductTypeBySlug("pallets");

const GradingTool = lazyComponent(
  () => import("@/components/features/grading/grading-tool").then((module) => module.GradingTool),
  {
    loading: <div aria-hidden className="h-96 animate-pulse rounded-3xl bg-muted motion-reduce:animate-none" />,
    ssr: false,
    failure: {
      label: "landing-grading-tool",
      fallback: (
        <p className="py-16 text-center text-sm text-fg-muted">
          The grader didn&apos;t load.{" "}
          <Link href="/grade" prefetch={false} className="font-medium text-brand-strong underline">
            Open it on its own page
          </Link>
        </p>
      ),
    },
  },
);

export const LandingSpecSheetDemo = lazyComponent(
  () => import("./landing-tool-spec-sheet").then((module) => module.LandingToolSpecSheet),
  {
    loading: <div aria-hidden className="h-96 animate-pulse rounded-xl bg-muted motion-reduce:animate-none" />,
    ssr: false,
    failure: {
      label: "landing-spec-sheet-demo",
      fallback: (
        <p className="py-16 text-center text-sm text-fg-muted">
          The demo didn&apos;t load.{" "}
          <Link href="/dashboard/spec-sheets/new" prefetch={false} className="font-medium text-brand-strong underline">
            Open the spec sheet builder
          </Link>
        </p>
      ),
    },
  },
);

export function LandingGradingTool() {
  return <GradingTool productType={GRADED_PALLET} sourcePath="/" showHeading={false} />;
}
